export const REQUEST_OTP = 'REQUEST_OTP';
export const OTP_RECEIVED = 'OTP_RECEIVED';

